import BoldText from '@/components/BoldText';
import RegularText from '@/components/RegularText';
import { ICon } from '@/constants/enum';
import { useChannelSelected } from '@/hooks/useChannelSelected';
import widgetSlice, { customizeSelected } from '@/redux/slice/widget.slice';
import { IParamsApi } from '@/types/apis/params';
import { Button, Link } from '@shopify/polaris';
import { MinusIcon } from '@shopify/polaris-icons';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MessageStyled } from './styled';
import { listDefaultAvatarAgents } from '@/components/ChannelsButton/Component/ModalAgent';
interface IProps {
  handleCloseWindow: () => void;
  agentSelected?: IParamsApi.IAgent;
}
const MessageWindow = ({ handleCloseWindow, agentSelected }: IProps) => {
  const dispatch = useDispatch();
  const message = useChannelSelected(ICon.Messenger).channel;
  const data = useChannelSelected(ICon.Messenger).channel?.advance;
  const customize = useSelector(customizeSelected);
  const handleClose = () => {
    handleCloseWindow();
    dispatch(widgetSlice.actions.handleWindow(undefined));
  };

  const filterAvatarAgent = () => {
    if (agentSelected) {
      const avatarUrl = agentSelected.customAvatar
        ? agentSelected.customAvatar
        : listDefaultAvatarAgents.find((avatar) => avatar.id === agentSelected.avatarId)?.url;
      return avatarUrl;
    }
  };

  return (
    <MessageStyled borderRadius={customize.buttonStyle}>
      <div className="message-header-container">
        {filterAvatarAgent() || message?.advance?.messengerProfileImage?.url ? (
          <img
            alt=""
            style={{ width: `${24}px`, height: `${24}px`, borderRadius: '50%' }}
            src={filterAvatarAgent() || message?.advance?.messengerProfileImage?.url}
          />
        ) : null}
        <div onClick={handleClose}>
          <Button variant="plain" icon={MinusIcon} />
        </div>
      </div>
      <BoldText>{data?.messengerTitle}</BoldText>
      <RegularText>{data?.messengerWelcomeMessage}</RegularText>

      <div className="input-container">
        <input placeholder={message?.advance?.messengerPlaceholderText}></input>
        <div className="messenger-chat-widget-action-send">
          <svg height="20px" viewBox="0 0 24 24" width="20px">
            <path
              d="M16.6915026,12.4744748 L3.50612381,13.2599618 C3.19218622,13.2599618 3.03521743,13.4170592 3.03521743,13.5741566 L1.15159189,20.0151496 C0.8376543,20.8006365 0.99,21.89 1.77946707,22.52 C2.41,22.99 3.50612381,23.1 4.13399899,22.8429026 L21.714504,14.0454487 C22.6563168,13.5741566 23.1272231,12.6315722 22.9702544,11.6889879 C22.8132856,11.0605983 22.3423792,10.4322088 21.714504,10.118014 L4.13399899,1.16346272 C3.34915502,0.9 2.40734225,1.00636533 1.77946707,1.4776575 C0.994623095,2.10604706 0.8376543,3.0486314 1.15159189,3.99121575 L3.03521743,10.4322088 C3.03521743,10.5893061 3.34915502,10.7464035 3.50612381,10.7464035 L16.6915026,11.5318905 C16.6915026,11.5318905 17.1624089,11.5318905 17.1624089,12.0031827 C17.1624089,12.4744748 16.6915026,12.4744748 16.6915026,12.4744748 Z"
              fill="#1E88E5"
            ></path>
          </svg>
        </div>
      </div>
      <div className="bottom">
        <RegularText>
          Powered by{' '}
          <Link url="https://www.omegatheme.com/" target="_blank">
            Omega
          </Link>
        </RegularText>
      </div>
    </MessageStyled>
  );
};

export default memo(MessageWindow);
